import { useCallback, useState } from "react";
import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { BlockProps } from "../types";
import { useBlock } from ".";

export type PaymentsSubsection = "log-purchase" | "charge";

export interface UsePaymentsBlockArgs extends BlockProps {}

export const usePaymentsBlock = (args: UsePaymentsBlockArgs) => {
  const block = useBlock({ ...args, type: "payments.payments", select: (enduser) => enduser });

  const [activeSubsection, setActiveSubsection] = useState<PaymentsSubsection>();
  const [selectedPurchase, setSelectedPurchase] = useState<TellescopeModelFromName<"purchases">>();

  const openSubsection = useCallback((subsection: PaymentsSubsection) => {
    setSelectedPurchase(undefined);
    setActiveSubsection(subsection);
  }, []);
  const closeSubsection = useCallback(() => setActiveSubsection(undefined), []);

  const openPurchase = useCallback((purchase: TellescopeModelFromName<"purchases">) => {
    setActiveSubsection(undefined);
    setSelectedPurchase(purchase);
  }, []);
  const closePurchase = useCallback(() => setSelectedPurchase(undefined), []);

  const enduser = block.enduserQuery.data;

  return {
    ...block,
    enduser,
    activeSubsection,
    openSubsection,
    closeSubsection,
    selectedPurchase,
    openPurchase,
    closePurchase,
  };
};
